import {
  insertFormTabChildrenAfterOther,
  isCustomFormCategory,
} from "components/DynamicForms/shared/formCategoryUtils";

export const SIL_FORMS_TAB_ID = "forms";
export const SIL_FORMS_OTHER_TAB_ID = "form-others";

export const customSilFormCategoryTabId = (categoryId) =>
  `form-custom-${categoryId}`;

export const isCustomSilFormCategoryTabId = (tabId) =>
  String(tabId || "").startsWith("form-custom-");

export const formCategoryTabFromCustomSilCategory = (category) => ({
  name: category.name,
  id: customSilFormCategoryTabId(category.id),
  children: [],
  slug: category.slug,
  categoryUuid: category.uuid,
  isCustomFormCategory: true,
});

/** Home profile Forms menu: platform categories, then custom categories after Others. */
export const mergeCustomSilCategoriesIntoFormsTab = (tabs, customCategories) => {
  if (!customCategories?.length) {
    return tabs;
  }

  const customChildren = customCategories
    .filter(isCustomFormCategory)
    .map(formCategoryTabFromCustomSilCategory);

  return tabs.map((tab) => {
    if (tab.id !== SIL_FORMS_TAB_ID || !tab.children?.length) {
      return tab;
    }

    const staticChildren = tab.children.filter(
      (child) => !child.isCustomFormCategory
    );

    return {
      ...tab,
      children: insertFormTabChildrenAfterOther(
        staticChildren,
        SIL_FORMS_OTHER_TAB_ID,
        customChildren
      ),
    };
  });
};
